<template>
  <div class="p-loading" v-if="isShow" :style="{ background: bgColor }">
    <div class="p-loading__item"></div>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: {},
  data() {
    return {
      isShow: true,
      opacity: 1
    };
  },
  computed: {
    bgColor() {
      return `rgba(255,255,255,${this.opacity})`;
    }
  },
  methods: {
    show(opacity = 1) {
      this.opacity = opacity;
      this.isShow = true;
    },
    hide() {
      this.isShow = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
